import { useEffect, useState } from "react";
import "./App.css";

import profileImg from "./assets/cvcvcv.jpeg";
import webProject1 from "./assets/Screenshot 2026-03-19 175040.png";
import webProject2 from "./assets/Screenshot 2026-03-19 175314.png";
import devProject1 from "./assets/Hero Section.png";
import devProject2 from "./assets/Screenshot 2026-06-19 144444.png";
import featureWebImg from "./assets/12345.png";
import creative1 from "./assets/nexora (4).png";
import creative2 from "./assets/buddah brands.jpg";
import creative3 from "./assets/nexor3.png";
import creative4 from "./assets/VITO PIZZA 1.png";
import creative5 from "./assets/party.png";
import creative6 from "./assets/Blue And Black Modern Car Sale Instagram Post.jpg";
import creative7 from "./assets/Cla200.png";
import creative9 from "./assets/ol;ivia.png";
import creative10 from "./assets/123.png";
import creative8 from "./assets/catapppa.png";
import oliviaPdf from "./assets/Olivia.pdf";
import resumePdf from "./assets/VirunaDesithaCV 2.pdf";


const webProjects = [
  {
    tag: "WordPress · Elementor",
    title: "Zoomx Products website",
    desc: "A custom-designed detergent company website focused on modern branding, clean product presentation, and responsive user experience.",
    tools: ["WordPress", "Elementor", "Responsive"],
    image: webProject1,
    link: "https://zoomx.lk",
  },
  {
    tag: "WordPress · Elementor",
    title: "Travel Agency Website",
    desc: "A fully designed and developed travel agency website created to showcase destinations, tours, and travel experiences with a modern and user-friendly layout.",
    tools: ["WordPress", "Modern", "Responsive"],
    image: webProject2,
    link: "https://nuviyanatravels.com/",
  },
    {
    tag: "WordPress · Elementor",
    title: "Party Tickets Booking Website",
    desc: "A modern ticket booking website designed to help users explore upcoming events, secure tickets instantly, and enjoy a seamless booking experience across all devices.",
    tools: ["WordPress", "Modern", "Redesign"],
    image: creative10,
    link: "https://partylab.lk/",
  },
   {
  tag: "WordPress · Elementor",
  title: "Olivia Tourism Website",
  desc: "Tourism website design created for showcasing destinations and travel experiences.",
  tools: ["WordPress", "Modern", "Redesign"],
  image: creative9,
  pdf: oliviaPdf,
  isPdf: true,
},
  
];

const devProjects = [
  {
    tag: " Final Year Project",
    title: "Tea Lens",
    desc: "A deep learning based tea leaf disease detection system developed to identify tea plant diseases and support smart agricultural decision making.",
    tools: ["React", "EfficientNetB3", "CNN Model"],
    image: devProject1,
    link: "https://tea-lens.web.app/",
  },
  {
    tag: "Group project",
    title: "Skin Sense",
    desc: "A mobile application designed to identify skin diseases using AI-powered image analysis and provide users with quick health related insights.",
    tools: ["ReactNative", "inceptionv3", "Mobile App"],
    image: devProject2,
    link: "https://virunadesitha.github.io/SkinSense_Marketing_Website/index.html",
  },
];

const creativeWorks = [
  {
    // tag: "Post Design",
    // title: "Brand Marketing Posts",
    image: creative1,
  },
  {
    // tag: "Social Media",
    // title: "Creative Promotional Designs",
    image: creative2,
  },
  {
    // tag: "Video Editing",
    // title: "Short Reels & Visual Content",
    image: creative3,
  },
   {
    // tag: "Video Editing",
    // title: "Short Reels & Visual Content",
    image: creative4,
  }, {
    // tag: "Video Editing",
    // title: "Short Reels & Visual Content",
    image: creative5,
  }, {
    // tag: "Video Editing",
    // title: "Short Reels & Visual Content",
    image: creative6,
  }, {
    // tag: "Video Editing",
    // title: "Short Reels & Visual Content",
    image: creative7,
  },
  {
    // tag: "Digital Design",
    // title: "Modern Campaign Visuals",
    image: creative8,
  },
];

function SectionTitle({ label, title, linkText = "View All" }) {
  return (
    <div className="section-header">
      <div>
        <div className="section-label">{label}</div>
        <h2 className="section-title">{title}</h2>
      </div>
      <a href="/" className="see-all" onClick={(e) => e.preventDefault()}>
        {linkText}
      </a>
    </div>
  );
}

function App() {
const [scrolled, setScrolled] = useState(false);
const [selectedPdf, setSelectedPdf] = useState(null);
const [showAllWebProjects, setShowAllWebProjects] = useState(false);
const openPdf = (pdf) => {
  document.body.style.overflow = "hidden";
  setSelectedPdf(pdf);
};

const closePdf = () => {
  document.body.style.overflow = "auto";
  setSelectedPdf(null);
};

const [position, setPosition] = useState({
  x: 0,
  y: 0,
});

useEffect(() => {
  
  const handleScroll = () => setScrolled(window.scrollY > 20);

  const moveCursor = (e) => {
    setPosition({
      x: e.clientX,
      y: e.clientY,
    });
  };

  window.addEventListener("scroll", handleScroll);
  window.addEventListener("mousemove", moveCursor);

  return () => {
    window.removeEventListener("scroll", handleScroll);
    window.removeEventListener("mousemove", moveCursor);
  };
}, []);

  return (
    <div className="portfolio">

  <div
    className="cursor-glow"
    style={{
      left: `${position.x}px`,
      top: `${position.y}px`,
    }}
  ></div>
      <nav className={`nav ${scrolled ? "nav-scrolled" : ""}`}>
        <div className="nav-logo">VIRUNA DESITHA</div>

        <div className="nav-links">
          <a href="#home" className="active">
            HOME
          </a>
          <a href="#work">WORK</a>
          <a href="#about">ABOUT</a>
        </div>

        <a
          href={resumePdf}
          download="VirunaDesithaCV 2.pdf"
           className="resume-btn"
          >
           RESUME
        </a>
      </nav>

      <section className="hero" id="home">
        <div className="hero-glow hero-glow-left"></div>
        <div className="hero-glow hero-glow-right"></div>

        <div className="hero-center">
          <div className="hero-badge">
            <span className="badge-dot"></span>
            AVAILABLE TO WORK
          </div>

          <h1 className="hero-title">VIRUNA DESITHA</h1>

          <p className="hero-description">
            I’m a Software Engineering graduate with a growing passion for
            web design, development, and digital creativity. I focus on
            building responsive websites, coding projects, and visual content
            that deliver both style and functionality.
          </p>

          <div className="hero-wave">
            <svg width="120" height="26" viewBox="0 0 120 26" fill="none">
              <path
                d="M2 13C10 13 10 3 18 3C26 3 26 23 34 23C42 23 42 3 50 3C58 3 58 23 66 23C74 23 74 3 82 3C90 3 90 23 98 23C106 23 106 13 118 13"
                stroke="#C8F028"
                strokeWidth="4"
                strokeLinecap="round"
              />
            </svg>
          </div>
        </div>

        <div className="hero-bottom">
          <div className="hero-bottom-left">
            <p>Turning ideas into digital experiences</p>
          </div>

          <div className="hero-bottom-right">
            <div className="ellipse"></div>
            <h2>by creativity.</h2>
          </div>
        </div>
      </section>

      <div className="marquee-strip">
        <div className="marquee-track">
          {[
            "WordPress Development",
            "UI Design",
            "Frontend Projects",
            "Post Design",
            "Video Editing",
            "Creative Branding",
            "Responsive Websites",
            "Digital Experiences",
            "WordPress Development",
            "UI Design",
            "Frontend Projects",
            "Post Design",
            "Video Editing",
            "Creative Branding",
            "Responsive Websites",
            "Digital Experiences",
          ].map((item, i) => (
            <span key={i}>{item}</span>
          ))}
        </div>
      </div>



      <section className="about section" id="about">
        <div className="about-left">
          <div className="section-label">About Me</div>
          <h2 className="section-title big-title">About Me</h2>

          <p className="about-text">
            I’m Viruna Desitha, a Software Engineering graduate passionate about 
            web development, web design, UI/UX design, WordPress development, and creative digital work.
          </p>

          <p className="about-text">
            I enjoy building modern, responsive, and user-friendly digital experiences. My work combines creativity, design thinking, 
            and technical expertise to create websites, user interfaces, and visual content that are clean, engaging, and functional.
            
          </p>

          <div className="about-stats">
            <div className="stat-card">
              <h3>01+</h3>
              <p>Years Experience</p>
            </div>
            <div className="stat-card">
              <h3>20+</h3>
              <p>Projects Done</p>
            </div>
            <div className="stat-card">
              <h3>10+</h3>
              <p>Websites Built</p>
            </div>
          </div>

          <div className="about-contact">
            <div>
              <span>Phone</span>
              <p>+94 77 5257 957</p>
            </div>
            <div>
              <span>Email</span>
              <p>virunadesitha2002@gmail.com</p>
            </div>
          </div>
        </div>

        <div className="about-right">
          <div className="profile-card">
            <div className="profile-ring"></div>
            <div className="profile-photo">
              <img src={profileImg} alt="Viruna Desitha" />
            </div>
          </div>
        </div>
      </section>

     


<section className="resume-section">

  <div className="resume-card">

    <div className="section-label">
      Resume
    </div>

    <h2 className="section-title">
      Education & Experience
    </h2>

    <div className="resume-grid">

      {/* EDUCATION */}

      <div className="resume-column">

        <h3>Education</h3>

        <div className="resume-item">
          <span className="resume-year">2022 - 2026</span>

          <h4>BEng (Hons) Software Engineering</h4>

          <p>
            Upper Second Class Honours
          </p>

          <small>
            Informatics Institute of Technology (IIT)
            <br />
            University of Westminster
          </small>
        </div>

        <div className="resume-item">
          <span className="resume-year">2023</span>

          <h4>Advanced Professional Java Developer</h4>

          <small>
            Academy of Computer Programming &
            Training
          </small>
        </div>

        <div className="resume-item">
          <span className="resume-year">2021</span>

          <h4>G.C.E Advanced Level</h4>

          <small>
            Physical Science Stream
            <br />
            Mahinda College - Galle
          </small>
        </div>

      </div>


      {/* EXPERIENCE */}

      <div className="resume-column">

        <h3>Experience</h3>

        <div className="resume-item">

          <span className="resume-year">
            Aug 2024 – Aug 2025
          </span>

          <h4>
            Web Designer Intern
          </h4>

          <p>
            Weblook International (Pvt) Ltd
          </p>

          <small>
            WordPress, Elementor, UI Design,
            Responsive Websites, QA Testing,
            Client Websites
          </small>

        </div>

      </div>


      {/* SKILLS */}

      <div className="resume-column">

        <h3>Skills</h3>

        <div className="skills-wrap">

          {[
            "Web Design",
            "Development",
            "UI/UX",
            "Figma",
            "Photoshop",
            "WordPress",
            "QA Testing",
            "SEO",
            "Java",
            "React"
          ].map(skill=>(
            <span className="skill-pill">
              {skill}
            </span>
          ))}

        </div>

      </div>

    </div>

  </div>

</section>



<section className="projects section" id="work">
  <SectionTitle
    label="Portfolio"
    title="Web Design Projects"
    linkText="See All Projects"
  />

  <div className="project-grid">
    {(showAllWebProjects
      ? webProjects
      : webProjects.slice(0, 2)
    ).map((project, index) => (
      <div className="project-card" key={index}>
        <div className="project-thumb">
          <img
            src={project.image}
            alt={project.title}
            className="project-image"
          />
        </div>

        <div className="project-content">
          <span className="project-tag">{project.tag}</span>

          <h3>{project.title}</h3>

          <p>{project.desc}</p>

          <div className="project-tools">
            {project.tools.map((tool, i) => (
              <span key={i}>{tool}</span>
            ))}
          </div>
{project.isPdf ? (
<button
  className="project-link"
  onClick={() => openPdf(project.pdf)}
>
  View Design →
</button>
) : (
  <a
    href={project.link}
    target="_blank"
    rel="noopener noreferrer"
    className="project-link"
  >
    Visit Website →
  </a>
)}
        </div>
      </div>
    ))}
  </div>

  {webProjects.length > 2 && (
    <div className="show-more-wrapper">
      <button
        className={`show-more-btn ${
          showAllWebProjects ? "active" : ""
        }`}
        onClick={() =>
          setShowAllWebProjects(!showAllWebProjects)
        }
      >
        ↓
      </button>
    </div>
  )}
  {selectedPdf && (
  <div
    className="pdf-modal"
    onClick={closePdf}
  >
    <div
      className="pdf-content"
      onClick={(e) => e.stopPropagation()}
    >
     <button
  className="close-btn"
  onClick={closePdf}
>
  ✕
</button>

      <iframe
        src={selectedPdf}
        title="Olivia Tourism Design"
        width="100%"
        height="100%"
      />
    </div>
  </div>
)}
</section>

      <section className="feature-strip">
        <div className="feature-left">
          <div className="feature-image-wrap">
            <img
              src={featureWebImg}
              alt="Featured web project"
              className="feature-image"
            />
          </div>
        </div>

        <div className="feature-right">
          <span className="feature-tag">Highlighted Work</span>
          <h3>
            I create websites that combine <strong>clean visuals</strong> with{" "}
            <strong>practical functionality.</strong>
          </h3>
          <p>
            My focus is on building user-friendly digital experiences that look
            modern, feel smooth, and communicate clearly.
          </p>
          <a href="/" className="outline-btn" onClick={(e) => e.preventDefault()}>
            View Case Study
          </a>
        </div>
      </section>

      <section className="projects section dark-section">
        <SectionTitle
          label="Development"
          title="DEVELOPMENT"
          linkText="View All Projects"
        />

        <div className="project-grid">
          {devProjects.map((project, index) => (
            <div className="project-card" key={index}>
              <div className="project-thumb dark-thumb">
                <img
                  src={project.image}
                  alt={project.title}
                  className="project-image"
                />
              </div>

<div className="project-content">
  <span className="project-tag">{project.tag}</span>
  <h3>{project.title}</h3>
  <p>{project.desc}</p>

  <div className="project-tools">
    {project.tools.map((tool, i) => (
      <span key={i}>{tool}</span>
    ))}
  </div>

  <a
    href={project.link}
    target="_blank"
    rel="noopener noreferrer"
    className="project-link"
  >
    View Project →
  </a>
</div>
            </div>
          ))}
        </div>
      </section>

      <section className="philosophy section">
        <div className="philosophy-left">
          <h2>
            Beyond
            <br />
            <span>Pixels.</span>
          </h2>
        </div>

        <div className="philosophy-right">
          <p>
            I believe design is the connection between ideas and experiences. I
            don’t just try to make things look good , I aim to make them feel
            useful, modern, and memorable. My process is built on creativity,
            structure, and attention to detail.
          </p>
        </div>
      </section>

      <section className="creative section">
        <SectionTitle
          label="Creative"
          title="Post Design"
          linkText="View All Works"
        />

        <div className="creative-grid">
          {creativeWorks.map((item, index) => (
            <div className="creative-card" key={index}>
              <img
                src={item.image}
                alt={item.title}
                className="creative-image"
              />
              <div className="creative-overlay">
                <span>{item.tag}</span>
                <h3>{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </section>


      <section className="contact section" id="contact">
        <div className="contact-left">
          <div className="section-label">Contact</div>
          <h2 className="section-title big-title">Let’s Work Together</h2>
          <p className="contact-text">
            Have a project idea or want to collaborate? I’m always interested
            in creating meaningful digital experiences through design and
            development.
          </p>
        </div>

        <div className="contact-right">
          <a href="mailto:viruna@example.com" className="contact-link-card">
            <span>Email</span>
            <strong>virunadesitha2002@gmail.com</strong>
          </a>
          <a href="linkedin.com/in/viruna-abeywickrama-9b8517260" className="contact-link-card" onClick={(e) => e.preventDefault()}>
            <span>LinkedIn</span>
            <strong>linkedin.com/in/viruna</strong>
          </a>
          <a href="/" className="contact-link-card" onClick={(e) => e.preventDefault()}>
            <span>GitHub</span>
            <strong>github.com/viruna</strong>
          </a>
          <a href="tel:+94771234567" className="contact-link-card">
            <span>Phone</span>
            <strong>+94 77 5257 957</strong>
          </a>
        </div>
      </section>

      <footer className="footer">
        <div className="footer-left">
          <p className="footer-top-text">Got an idea?</p>
          <h2>VIRUNA</h2>
        </div>

        <div className="footer-right">
          <div className="footer-col">
            <span>SITEMAP</span>
            <a href="#home">Home</a>
            <a href="#work">Work</a>
            <a href="#about">About</a>
          </div>

          <div className="footer-col">
            <span>SERVICES</span>
            <a href="/">Web Design</a>
            <a href="/">Development</a>
            <a href="/">Creative Work</a>
          </div>

          <div className="footer-col">
            <span>CONTACT</span>
            <a href="mailto:viruna@example.com">virunadesitha2002@gmail.com</a>
            <a href="tel:+94771234567">+94 77 5257 957</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;